/* MQA: light right-click deterrent on the product gallery. Blocks the browser context menu
   over product images so casual "Save image as…" is discouraged — WITHOUT disabling zoom,
   lightbox, or the frame-preview overlay (the old approach used pointer-events:none, which
   killed all of those and targeted 5.0.1 class names that no longer exist in 6.0.1).
   This is a soft deterrent only; anyone determined can still bypass it via devtools. */
(function () {
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.product__primary-left, .product__media-container, .lightbox-media-container')) {
      e.preventDefault();
    }
  }, false);
})();
